// extracted by mini-css-extract-plugin
export var centerText = "_5s-8";
export var container = "_5s-0";
export var doughnutContainer = "_5s-7";
export var legend = "_5s-a";
export var legendItemColorDisplay = "_5s-b";
export var legendItemLabel = "_5s-d";
export var legendItemValue = "_5s-c";
export var lg = "_5s-5";
export var maxWidth = "_5s-9";
export var md = "_5s-4";
export var responsive = "_5s-6";
export var sm = "_5s-3";
export var xs = "_5s-2";
export var xxs = "_5s-1";